/* eslint-disable import/no-anonymous-default-export */
import FlagGeorgianSVGR from "../../smart-assets/SVGRs/FlagGeorgianSVGR";

export default {
  key: "Geo",
  routeKey: "ka",
  FlagSVGR: FlagGeorgianSVGR,
  displayText: "ქართული",
  pages: { // გვერდები
    homePage: { // მთავარი გვერდი
      welcomeBanner: { // მთავარი გვერდის ბანერი
        title: "ლიდერქარდის უპირატესობები",
        benefitsList: {
          digitalPayment: "უკონტაქტო გადახდა",
          cashback: "10% ქეშბექი",
          giftedPoints: "1000 ქულა საჩუქრად ბეთმარკეტში",
        },
        buttons: {
          request: "მოითხოვე",
          more: "გაიგე მეტი",
        },
      },
      features: { // მთავარი გვერდის 4 უპირატესობა
        verified: "კონფიდენციალურობის მაღალი დონე",
        discount: "ფასდაკლების საშუალება",
        coin: "მარტივი გადახდის საშუალება",
        dollar: "თანხის განაღდების მარტივი გზა",
      },
    },
    about: { // ჩვენ შესახებ
      aboutUs: "ჩვენ შესახებ",
      aboutUsParagraph: "www.leadercard.ge წარმოადგენს შპს ენ ბი სი-ს საკუთრებას. შპს ენ ბი სი არის  საქართველოს ეროვნული ბანკის მიერ ლიცენზირებული ელეტქრონული საფულე, რომელიც ქართულ ბაზარზე ფუნქციონირებს 2017 წლიდან. ლიდერქარდი თავის მომხარებლებს სთავაზობს უნიკალურ, უკონტაქტო საბანკო ტიპის ჩიპიან ბარათს. ბარათის მფლობელებს აქვთ შესაძლებლობა leader-bet.com ის ანგარიშზე არსებული თანხები განკარგონ ბარათის მეშვეობით.",
      howItFunctions: "როგორ ფუნქციონირებს?",
      howItFunctionsParagraph: "მომხმარებლებს შეუძლიათ მარტივად გადაიტანონ მოგებული თანხა ლიდერქარდის ანგარიშზე, სურვილისამებრ გაანაღდონ ან გადაიხადონ საქართველოს ბანკისა და თიბისი ბანკის ბანკომატებისა და ტერმინალების საშუალებით მთელი საქართველოს მასშტაბით.",
      whatConditions: "რა პირობებს გთავაზობთ?",
      conditionsListArray: [
        "თანხის განაღდება უფასოდ, ყოველგვარი საკომისიოს გარეშე",
        "განაღდების დღიური ლიმიტი 3000 ლარი",
        "გადაიხადეთ ნებისმიერ სავაჭრო ობიექტში ლიდერქარდით და ისარგებლეთ 10% მომენტალური ქეშბექით, ანუ მარტივად, დაიბრუნეთ გადახდილი თანხის 10% ყველგან და ყველაფერზე.",
      ],
      easyAccess: "ლიდერქარდის აღება უფასოა ლიდერბეთის სალაროებსა და ლიდერქარდის სარეკლამო ჯიხურებში, ან მარტივად ონლაინ გამოწერით.",
      companyIdentificationInfo: "კომპანიის საიდენტიფიკაციო მონაცმეები:",
      company: "კომპანია შპს „ენ ბი სი“.",
      companyId: "ს.კ. 405150063",
    },
    policy:  {
      title: "კონფიდენციალობა",
      policy: `ვებ-გვერდს leadercard.ge-ს მართავს შპს „ენბისი“- (405150063) შემდგომში კომპანმია,რომელიც რეგისტრირებული და ლიცენზირებულია საქართველოს კანონმდებლობის შესაბამისად  როგორც საგადახდო მომსახურების პროვაიდერი.
      კომპანია  იცავს  და პატივს სცემს მომხმარებლის უფლებებს, ასევე უზრუნველყოფს მომხმარებლის უსაფრთხოებას საკუთარი მომსახურებით სარგებლობისას. კომპანია პირის  პერსონალური მონაცემების დამუშავებისა და შენახვისას მოქმედებს ,, პერსონალურ მონაცემთა დაცვის შესახებ“  საქართველოს კანონის შესაბამისად.
      პერსონალური მონაცემების დამუშავება კომპანიის მხრიდან ხდება მხოლოდ კანონით გათვალისწინებული საფუძვლების არსებობისას და მათი დამუშავებისას კომპანია იცავს კანონით გათვალისწინებული ყველა მოთხოვნას:
      ა) მონაცემები მუშავდება   სამართლიანად და კანონიერად, მონაცემთა სუბიექტის ღირსების შეულახავად.
      ბ) მონაცემები შეიძლება დამუშავდეს მხოლოდ კონკრეტული, მკაფიოდ განსაზღვრული, კანონიერი მიზნებისათვის.  კომპანია  არ ახორციელებს პერსონალური მონაცემების ისეთ დამუშავებას, რომელიც  თავდაპირველ მიზანთან შეუთავსებელია.
      გ) მონაცემები შეიძლება დამუშავდეს მხოლოდ იმ მოცულობით, რომელიც აუცილებელია შესაბამისი კანონიერი მიზნის მისაღწევად. მონაცემების დამუშავება ხდება იმ მიზნის ადეკვატურად  და პროპორციულად , რომლის მისაღწევადაც მუშავდება ის. 
      დ) მონაცემების ნამდვილობასა და სიზუსტეს ამოწმებენ შესაბამისი თანამშრომლები ასევე   საჭიროების შემთხვევაში ხდება აღნიშნული ინფორმაციის განახლება. 
      კომპანია მონაცემებს ამუშავებს მაშინ როდესაც, ხდება მომხმარებლის სისტემაში რეგისტრაცია და შემდგომში მისთვის მომსახურების გაწევა  ან/და მონაცემების დამუშავება საჭიროა მარეგულირებლის მოთხოვნებით გათვალისწინებული მოვალეობის შესასრულებლად.
      კომპანიის ვებ-გვერდი იყენებს მონაცემთა შეგროვების ავტომატურ სისტემას, როგორიცაა Cookies. Cookies არის მოწყობილობა, რომელიც გადაცემულია ინტერნეტ მომხმარებლის მყარ დისკზე. ის არ შეიცავს გასაგებ ინფორმაციას, მაგრამ ის საშუალებას აძლევს ინტერნეტ მომხმარებელს დაუკავშირდეს მის პერსონალურ მონაცემებს, რომლებიც ხელმისაწვდომია მომხმარებლების მიერ leadercard.ge-ზე. Cookies არის გავრცელებული ჩვენს სერვერებში და არავისთვის არ არის მისაწვდომი ის ინფორმაცია, რომელიც ინახება მასში. მხოლოდ კომპანია ამუშავებს Cookies მიერ შეგროვებულ ინფორმაციას ერთიანად და ანონიმურად, იმისთვის რომ მოხდეს მისი მომსახურებისა და ვებ-გვერდის ოპტიმიზაცია მომხმარებელთა საჭიროების და უპირატესობის შესაბამისად.მონაცემთა ავტომატურად შეგროვების პროცედურის და Cookies გამოყენების შესახებ თანხმობა არის აუცილებელი ვებ-გვერდისა და მისი მომსახურების სარგებლობისთვის, თუ თქვენ არ გნებავთ, რომ თქვენმა ბრაუზერმა თანხმობა განაცხადოს Cookies-ზე, თქვენ შეგიძლიათ გამორთოთ Cookies მიღების ოფცია თქვენი ბრაუზერის პარამეტრებიდან.
      
      მომხმარებელს აქვს  უფლება მოითხოვოს საკუთარი პირადი მონაცემების გასწორება, განახლება, დამატება, დაბლოკვა, წაშლა ან განადგურება თუ ისინი არასრულია, არაზუსტია, არ არის განახლებული ან თუ მათი შეგროვების ან/და დამუშავებისას მომხმარებელმა გადაიფიქრა კომპანიასთან საქმიან ურთიერთობაში შესვლა ან/და სურვილი აქვს საქმიანი ურთიერთობის შეწყვეტისა, მაგრამ რადგან კომპანია მოქმედებს  საქართველოს კანონმდებლობების შესაბამისად, შესაძლოა ხელი შეეშალოს მომხმარებლის პერსონალური მონაცემების დაუყოვნებლივ განადგურებისას. მომხმარებლის მონაცემების სხვადასხვა ვადით შენახვის და შესაბამისად დამუშავების  ვალდებულებები შესაძლოა გამომდინარეობდეს ,,ფულის გათეთრების წინააღმდეგ ბრძოლის“, საგადასახადო კანონმდებლობის, ,,საგადახდო სისტემისა და საგადახდო მომსახურების შესახებ“და ,,მომხმარებელთა უფლებების დაცვის შესახებ’’ კანონმდებლობიდან.
      აღნიშნული ინფორმაციის მომხმარებლისთვის მიწოდების ვალდებულება კომპანიას  წარმოეშვება მომხმარებლის  მოთხოვნის შემთხვევაში. პერსონალური მონაცემების გამოყენების უფლებას კომპანია იტოვებს  მხოლოდ იმ შემთხვევაში, როცა ამისათვის კონკრეტული სახელშეკრულებო ან/და კანონისმიერი საფუძველი არსებობს .
      დამუშავებული მონაცემების კონფიდენციალობა დაცულია კანონმდებლობის შესაბამისად. კომპანიის ორგანიზაციული და ტექნიკური რესურსები, უზრუნველყოფს კონფიდენციალური ინფორმაციის  დაცვას შემთხვევითი ან უკანონო განადგურებისაგან, შეცვლისაგან, გამჟღავნებისაგან, მოპოვებისაგან, ნებისმიერი სხვა ფორმით უკანონო გამოყენებისა და შემთხვევითი ან უკანონო დაკარგვისაგან.
      კომპანია არ ამუშავებს  განსაკუთრებული კატეგორიის მონაცემებს, რომელთა დამუშავებაც კანონმდებლობითაა აკრძალული.
      `
    },
    faq: {
      title: "გაქვს რაიმე შეკითხვა?",
      description: "პრობლემის გადასაჭრელად აირჩიე შესაბამისი კატეგორია და მოძებნე შენთვის სასურველ კითხვებზე პასუხი",
      sections: {
        card: "ლიდერქარდი",
        bank: "ბანკი",
        discount: "ფასდაკლება",
      },
      questions: "კითხვები",
      information: "ინფორმაცია",
      searchInstructions: "ან ჩაწერე საძიებო ველში ნებისმიერი სიტყვა და მოძებნე შენთვის საინტერესო კითხვაზე პასუხი",
      FAQSearch: {
        searchPlaceholder: "საძიებო სიტყვა",
        sadlyNothing: "სამწუხაროდ ვერაფერი",
        wasFound: "მოიძებნა",
      },
    },
    contact: {
      title: "დაგვიტოვე შეტყობინება",
      instruction: "მოგვწერე ნებისმიერი სახის ინფორმაცია და ჩვენ მას აუცილებლად განვიხილავთ ჩვენ გუნდთთან ერთად",
      nameLabel: "სახელი",
      emailLabel: "E-mail",
      messagePlaceholder: "შეტყობინება",
      buttonText: "გაგზავნა",
      informationBoxText: "ინფორმაცია",
      informationLineText: "ინფორმაცია",
      contactList: {
        location: {
          title: "მისამართი",
          content: "ოთარ ონიაშვილის ქ. #1 . სართული 3",
        },
        email: {
          title: "ფოსტა",
          content: "info@nbc.ge",
        },
        phone: {
          title: "ტელეფონი",
          content: "+995 032 2 193293\n10:00 - 22:00",
        },
      },
    },
    register: {
      title: "რეგისტრაცია",
      requirement: "ბარათის შესაკვეთად აუცილებელია , იყო დარეგისტრირებული ჩვენს საიტზე და ასევე გქონდეს ლიდერბეთის ვერეფიცირებული ანგარიში.",
      statusModal: {
        text: "თქვენ წარმატებით გაიარეთ რეგისტრაცია",
        buttonText: "მთავარი გვერდი",
      },
      SMSModal: {
        title: "რეგისტრაცია",
        buttonText: "დადასტურება",
        smsCode: "SMS კოდი",
        wrongSMSCode: "SMS კოდი არასწორია",
      },
      stepOne: {
        privateInformation: {
          headerText: "პირადი ინფორმაცია",
          genderRadios: {
            male: "მამრობითი",
            female: "მდედრობითი",
          },
          name: "სახელი",
          last_name: "გვარი",
          patronymic: "მამის სახელი",
          personal_id: "პირადი ნომერი",
        },
        birthPlaceAndAddress: {
          headerText: "დაბადების ადგილი და თარიღი",
          birth_city: "ქალაქი",
          birth_country: "ქვეყანა",
          citizenship: "მოქალაქეობა",
          birth_date: "დაბადების თარიღი",
        },
        cardInformation: {
          headerText: "ბარათის ინფორმაცია",
          document_number: "დოკუმენტის ნომერი",
          issue_date: "გაცემის თარიღი",
          valid_date: "მოქმედების ვადა",
          issuer_org: "დოკუმენტის გამცემი ორგანო",
          issuer_org_DEFAULT_VALUE: "იუსტიციის სახლი",
          issuer_country: "გამცემი ქვეყანა",
        },
        legalAddress: {
          headerText: "იურიდიული მისამართი",
          legal_address: "მისამართი",
          legal_city: "ქალაქი",
          legal_country: "ქვეყანა",
        },
        legal_equals_fact_address: "ემთხვევა ფაქტობრივ მისამართს",
        factAddress: {
          headerText: "ფაქტობრივი მისამართი",
          fact_address: "მისამართი",
          fact_city: "ქალაქი",
          fact_country: "ქვეყანა",
        },
        contactInformation: {
          headerText: "საკონტაქტო ინფორმაცია",
          country_phone_code: "ქვეყნის სატელეფონო კოდი",
          phone: "ტელეფონი",
          email: "E-mail",
        },
      },
      stepTwo: {
        status: {
          headerText: "სტატუსი",
          residentRadios: {
            resident: "რეზიდენტი",
          },
        },
        politicalActivity: {
          headerText: "ხართ თუ არა პოლიტიკურად აქტიური",
          headerSubText: "განმარტება*",
          popupText: "პოლიტიკურად აქტიური პირი - მნიშვნელოვანი საჯარო ან პოლიტიკური ფუნქციების შემსრულებელი ფიზიკური პირი, (გარდა საშუალო და დაბალი რანგის თანამდებობების პირებისა) ან/და მათი ოჯახის წევრები (მეუღლე , და, ძმა, მშობელი, შვილი/გერი და მისი მეუღლე).",
          politicalActivityStatusRadios: {
            yes: "დიახ",
            no: "არა",
          },
          political_activity_info: "დამატებითი ინფორმაცია",
        },
        safetyAndPurpose: {
          headerText: "ურთიერთობის მიზანი და განზრახული ხასიათი",
          usage_period: "მომსახურებით სარგებლობის პერიოდი",
          usage_period_DEFAULT_VALUE: "3 წელი",
          currency: "რა ვალუტაში ხორციელდება ოპერაციები",
          frequency: "ოპერაციების სავარაუდო სიხშირე",
          monthly_amount: "სავარაუდო თანხის მოცულობა",
          additional_info: "დამატებითი ინფორმაცია",
        },
        estimatedMonthlyIncome: {
          headerText: "სავარაუდო ყოველთვიური შემოსავალი ლარებში",
        },
        incomeSource: {
          headerText: "შემოსავლის მიღების წყარო",
          income_info: "დამატებითი ინფორმაცია",
          employment_full_name: "დამსაქმებლის სრული დასახელება",
          employment_form: "დამსაქმებლის იურიდიული ფორმა",
          employee_position: "თანამდებობა",
          bank_names: "მომსახურე ბანკები",
          bank_services: "ბანკის სერვისები",
        },
      },
      stepThree: {
        documentCopy: {
          headerText: "დოკუმენტის ასლი",
          frontSide: {
            title: "წინა მხარე",
            description: "გთხოვთ ატვირთოთ პირადობის დამადასტურებელი მოწმობის წინა მხარე",
          },
          backSide: {
            title: "უკანა მხარე",
            description: "გთხოვთ ატვირთოთ პირადობის დამადასტურებელი მოწმობის უკანა  მხარე",
          },
        },
      },
      imageUpload: {
        deleteFile: "ფაილის წაშლა",
        captureWithCamera: "გადაიღე კამერით",
      },
      backButtonText: "უკან",
      nextButtonText: "შემდეგი",
      submitButtonText: "დასრულება",
      errors: {
        required: "* სავალდებულო ველი",
        onlyGeorgianCharacters: "* დაიშვება მხოლოდ ქართული სიმბოლოები",
        personal_id: "* აუცილებელია 11 ციფრი",
        phone: "* აუცილებელია 9 ციფრი",
        email: "* შეიყვანეთ სწორი E-mail",
        number: "* შეიყვანეთ რიცხვი",
        onlyDigits: "* მხოლოდ ციფრები",
        atLeastOne: "* სავალდებულოა მინიმუმ ერთის არჩევა",
        document_number: "* აუცილებელია 9 სიმბოლო",
        personal_id_registered: "პირადი ნომერი უკვე რეგისტრირებულია, გთხოვთ გაიაროთ ავტორიზაცია",
        document_number_registered: "დოკუმენტის ნომერი უკვე რეგისტრირებულია, გთხოვთ გაიაროთ ავტორიზაცია",
      },
    },
    dashboard: {
      profileTitle: "პროფილი",
      balanceTitle: "ბალანსი",
      profile: {
        privateInformation: {
          title: "პირადი ინფორმაცია",
          name: "სახელი",
          lastName: "გვარი",
          personalId: "პირადი ნომერი",
          phoneNumber: "მობილურის ნომერი",
        },
        resetPassword: {
          title: "პაროლის შეცვლა",
          currentPassword: "მიმდინარე პაროლი",
          newPassword: "ახალი პაროლი",
          repeatNewPassword: "გაიმეორე ახალი პაროლი",
          buttonText: "პაროლის დაყენება",
          SMSModal: {
            title: "პაროლის შეცვლა",
            buttonText: "დადასტურება",
            smsCode: "SMS კოდი",
            wrongSMSCode: "SMS კოდი არასწორია",
          },
          statusModal: {
            text: "თქვენ წარმატებით შეცვალეთ პაროლი",
            buttonText: "უკან დაბრუნება",
          },
        },
        pinRecovery: {
          title: "ბარათის პინის აღდგენა",
          description: "თუ დაგავიწყდათ ბარათის პინ კოდი, შეგიძლიათ მოითხოვოთ ახალი. უკვე შეცვლილი პინ კოდის შემთხვევაში, მისი გამოგზავნა არ ხდება",
          requestPin: "მოითხოვე პინი",
          pinSent: "პინ კოდი გამოგზავნილია თქვენ მობილურის ნომერზე",
        },
        safety: "უსაფრთხოება",
      },
      balance: {
        nbcBalance: "NBC ბალანსი",
        transferToLeaderbet: "ლიდერბეთზე გადარიცხვა",
        transactionHistory: "ტრანზაქციების ისტორია",
        from: "დან",
        to: "მდე",
        input: "შეტანა",
        output: "გატანა",
        allTransactions: "ყველა ტრანზაქცია",
        transferToLeaderbetForm: {
          amount: "თანხა",
          pinCode: "პინ კოდი",
          buttonText: "გადარიცხვა",
          transferAgainButtonText: "ახლიდან გადარიცხვა",
          successMessage: "ლიდერბეთზე გადაირიცხვა წარმატებით შესრულდა",
          errorMessage: "ლიდერბეთზე გადარიცხვა ვერ შესრულდა",
          pinNumber: "პინის ნომერი",
          smsCode: "SMS კოდი",
          errorStatuses: {
            "-1": "NBC-ის მომხმარებლის სახელი არ ემთხვევა ლიდერბეთის მომხმარებლის სახელს",
            "-2": "NBC-ის მომხმარებლის გვარი არ ემთხვევა ლიდერბეთის მომხმარებლის გვარს",
            "-3": "მომხმარებელი არ არის ვერიფიცირებული ლიდერბეთზე",
            "-4": "მომხმარებლის პირადი ნომერი არ ემთხვევა პირად ნომერს ლიდერბეთის მხარეს (იმ შემთხვევაში თუ პინია მითითებული)",
            "-5": "მომხმარებლის პირადი ნომრით არ არსებობს მომხმარებელი ლიდერბეთის მხარეს",
            "-6": "მომხმარებლის პირადი ნომრით ლიდერბეთზე რეგისტრირებულია რამდენიმე მომხმარებელი",
            "-7": "არასაკმარისი თანხა ანგარიშზე",
            "-8": "SMS კოდი არასწორია",
            "-10": "უცნობი შეცდომა",
          }
        },
        transactionModal: {
          title: "გადარიცხვა",
        },
        transactionStatuses: {
          1: "ლიდერბეთიდან ჩარიცხვა",
          2: "ლიდერბეთზე გადარიცხვა",
          3: "გადახდა",
          4: "თანხის ჩარიცხვა",
        },
      },
    },
    atms: {
      atmLocationsList: {
        city: "ქალაქი",
        clearFilter: "ფილტრაციის გაუქმება",
        pickCity: "აირჩიე ქალაქი",
        toViewAddresses: "მისამართების სანახავად",
      },
      addresses: "მისამართები",
    },
    terms:  {
      title: "წესები და პირობები",
      policy: `ვებ-გვერდს leadercard.ge-ს მართავს შპს „ენბისი“- (405150063) შემდგომში კომპანმია,რომელიც რეგისტრირებული და ლიცენზირებულია საქართველოს კანონმდებლობის შესაბამისად  როგორც საგადახდო მომსახურების პროვაიდერი.
      კომპანია  იცავს  და პატივს სცემს მომხმარებლის უფლებებს, ასევე უზრუნველყოფს მომხმარებლის უსაფრთხოებას საკუთარი მომსახურებით სარგებლობისას. კომპანია პირის  პერსონალური მონაცემების დამუშავებისა და შენახვისას მოქმედებს ,, პერსონალურ მონაცემთა დაცვის შესახებ“  საქართველოს კანონის შესაბამისად.
      პერსონალური მონაცემების დამუშავება კომპანიის მხრიდან ხდება მხოლოდ კანონით გათვალისწინებული საფუძვლების არსებობისას და მათი დამუშავებისას კომპანია იცავს კანონით გათვალისწინებული ყველა მოთხოვნას:
      ა) მონაცემები მუშავდება   სამართლიანად და კანონიერად, მონაცემთა სუბიექტის ღირსების შეულახავად.
      ბ) მონაცემები შეიძლება დამუშავდეს მხოლოდ კონკრეტული, მკაფიოდ განსაზღვრული, კანონიერი მიზნებისათვის.  კომპანია  არ ახორციელებს პერსონალური მონაცემების ისეთ დამუშავებას, რომელიც  თავდაპირველ მიზანთან შეუთავსებელია.
      გ) მონაცემები შეიძლება დამუშავდეს მხოლოდ იმ მოცულობით, რომელიც აუცილებელია შესაბამისი კანონიერი მიზნის მისაღწევად. მონაცემების დამუშავება ხდება იმ მიზნის ადეკვატურად  და პროპორციულად , რომლის მისაღწევადაც მუშავდება ის. 
      დ) მონაცემების ნამდვილობასა და სიზუსტეს ამოწმებენ შესაბამისი თანამშრომლები ასევე   საჭიროების შემთხვევაში ხდება აღნიშნული ინფორმაციის განახლება. 
      კომპანია მონაცემებს ამუშავებს მაშინ როდესაც, ხდება მომხმარებლის სისტემაში რეგისტრაცია და შემდგომში მისთვის მომსახურების გაწევა  ან/და მონაცემების დამუშავება საჭიროა მარეგულირებლის მოთხოვნებით გათვალისწინებული მოვალეობის შესასრულებლად.
      კომპანიის ვებ-გვერდი იყენებს მონაცემთა შეგროვების ავტომატურ სისტემას, როგორიცაა Cookies. Cookies არის მოწყობილობა, რომელიც გადაცემულია ინტერნეტ მომხმარებლის მყარ დისკზე. ის არ შეიცავს გასაგებ ინფორმაციას, მაგრამ ის საშუალებას აძლევს ინტერნეტ მომხმარებელს დაუკავშირდეს მის პერსონალურ მონაცემებს, რომლებიც ხელმისაწვდომია მომხმარებლების მიერ leadercard.ge-ზე. Cookies არის გავრცელებული ჩვენს სერვერებში და არავისთვის არ არის მისაწვდომი ის ინფორმაცია, რომელიც ინახება მასში. მხოლოდ კომპანია ამუშავებს Cookies მიერ შეგროვებულ ინფორმაციას ერთიანად და ანონიმურად, იმისთვის რომ მოხდეს მისი მომსახურებისა და ვებ-გვერდის ოპტიმიზაცია მომხმარებელთა საჭიროების და უპირატესობის შესაბამისად.მონაცემთა ავტომატურად შეგროვების პროცედურის და Cookies გამოყენების შესახებ თანხმობა არის აუცილებელი ვებ-გვერდისა და მისი მომსახურების სარგებლობისთვის, თუ თქვენ არ გნებავთ, რომ თქვენმა ბრაუზერმა თანხმობა განაცხადოს Cookies-ზე, თქვენ შეგიძლიათ გამორთოთ Cookies მიღების ოფცია თქვენი ბრაუზერის პარამეტრებიდან.
      
      მომხმარებელს აქვს  უფლება მოითხოვოს საკუთარი პირადი მონაცემების გასწორება, განახლება, დამატება, დაბლოკვა, წაშლა ან განადგურება თუ ისინი არასრულია, არაზუსტია, არ არის განახლებული ან თუ მათი შეგროვების ან/და დამუშავებისას მომხმარებელმა გადაიფიქრა კომპანიასთან საქმიან ურთიერთობაში შესვლა ან/და სურვილი აქვს საქმიანი ურთიერთობის შეწყვეტისა, მაგრამ რადგან კომპანია მოქმედებს  საქართველოს კანონმდებლობების შესაბამისად, შესაძლოა ხელი შეეშალოს მომხმარებლის პერსონალური მონაცემების დაუყოვნებლივ განადგურებისას. მომხმარებლის მონაცემების სხვადასხვა ვადით შენახვის და შესაბამისად დამუშავების  ვალდებულებები შესაძლოა გამომდინარეობდეს ,,ფულის გათეთრების წინააღმდეგ ბრძოლის“, საგადასახადო კანონმდებლობის, ,,საგადახდო სისტემისა და საგადახდო მომსახურების შესახებ“და ,,მომხმარებელთა უფლებების დაცვის შესახებ’’ კანონმდებლობიდან.
      აღნიშნული ინფორმაციის მომხმარებლისთვის მიწოდების ვალდებულება კომპანიას  წარმოეშვება მომხმარებლის  მოთხოვნის შემთხვევაში. პერსონალური მონაცემების გამოყენების უფლებას კომპანია იტოვებს  მხოლოდ იმ შემთხვევაში, როცა ამისათვის კონკრეტული სახელშეკრულებო ან/და კანონისმიერი საფუძველი არსებობს .
      დამუშავებული მონაცემების კონფიდენციალობა დაცულია კანონმდებლობის შესაბამისად. კომპანიის ორგანიზაციული და ტექნიკური რესურსები, უზრუნველყოფს კონფიდენციალური ინფორმაციის  დაცვას შემთხვევითი ან უკანონო განადგურებისაგან, შეცვლისაგან, გამჟღავნებისაგან, მოპოვებისაგან, ნებისმიერი სხვა ფორმით უკანონო გამოყენებისა და შემთხვევითი ან უკანონო დაკარგვისაგან.
      კომპანია არ ამუშავებს  განსაკუთრებული კატეგორიის მონაცემებს, რომელთა დამუშავებაც კანონმდებლობითაა აკრძალული.
      `
    },
  },
  globalComponents: { // გლობალური კომპონენტები
    getApp: {
      title: "Leadercard • e-wallet",
      descriptionAndroid: "Გადმოიწერე უფასოდ Play Store-დან.",
      descriptionIOS: "Გადმოიწერე უფასოდ App Store-დან.",
      buttonText: "გადმოწერა"
    },
    header: { // ჰედერი
      navigation: {
        home: "მთავარი",
        news: "სიახლე",
        atms: "სალაროები",
        faq: "FAQ",
        contact: "კონტაქტი",
        account: "ჩემი ანგარიში",
      },
      loginButton: "შესვლა",
    },
    footer: { // ფუტერი
      navigation: {
        about: "ჩვენ შესახებ",
        news: "სიახლეები",
        atms: "სალაროები",
        faq: "FAQ",
        contact: "კონტაქტი",
        getCard: "ბარათის დამზადება",
        policy: "კონფიდენციალობა",
        termsAndConditions:'წესები და პირობები'
      },
      copyright: "© შპს ენ ბი სი (ს/კ 405150063) NBC.GE - ყველა უფლება დაცულია.",
    },
    latestNews: {
      headerText: "ბოლო სიახლეები",
    },
    loginModal: {
      title: "ავტორიზაცია",
      personalId: "პირადი ნომერი",
      cardLastFourNumbers: "ბარათის ბოლო 4 ციფრი",
      setPassword: "დააყენე პაროლი",
      repeatPassword: "გაიმეორე პაროლი",
      setPasswordButtonText: "პაროლის დაყენება",
      loginButtonText: "შესვლა",
      smsCode: "SMS კოდი",
      password: "პაროლი",
      register: "რეგისტრაცია",
      errors: {
        physicalIDNotFound: "თქვენი პირადი ნომერი არ არის ჩვენს ბაზაში რეგისტრირებული. კიდევ  სცადეთ ან გაიარეთ ონლაინ რეგისტრაცია.",
        accountNotActivated: "თქვენი ანგარიში ელოდება დადასტურებას ადმინისტრატორის მიერ, გთხოვთ დაელოდოთ.",
        wrongPassword: "პაროლი არასწორია",
        cardLastFourNumbersNotFound: "მსგავსი ნომრით ბარათი არ არის თქვენს მომხმარებელზე რეგისტრირებული",
        wrongSMSCode: "SMS კოდი არასწორია",
        passwordsNoMatch: "გამეორებული პაროლი არ ემთხვევა თავდაპირველ პაროლს",
      },
      showPassword: "პაროლის ნახვა",
      hidePassword: "პაროლის დამალვა",
      mainPage: "მთავარი გვერდი",
      loading: "მუშავდება მონაცამები. გთხოთ მოიცადოთ რამოდენიმე წამი.",
      correctPhysicalID: "თქვენი პირადი ნომერი დადასტურდა.",
      correctCardLastFourNumbers: "თქვენი ბარათის ბოლო ოთხი ციფრი დადასტურდა",
      resetPasswordPrompt: "პაროლის აღდგენა",
      resettingPasswordButtonText: "პაროლის დაყენება",
    },
  },
  universal: {
    months: [
      "იანვარი",
      "თებერვალი",
      "მარტი",
      "აპრილი",
      "მაისი",
      "ივნისი",
      "ივლისი",
      "აგვისტო",
      "სექტემბერი",
      "ოქტომბერი",
      "ნოემბერი",
      "დეკემბერი",
    ],
    monthsShort: [
      "იან",
      "თებ",
      "მარ",
      "აპრ",
      "მაი",
      "ივნ",
      "ივლ",
      "აგვ",
      "სექ",
      "ოქტ",
      "ნოე",
      "დეკ",
    ],
  },
};